// COLORS
export const colorBlue = 'rgba(120, 190, 255)';
export const colorOrange = 'rgb(255,120,123)';
export const colorYellow = 'rgb(255,253,120)';
export const colorWhite = 'rgb(255, 255, 255)';
export const colorGray = 'rgb(244, 245, 246)';



// WEBPACK FOOTER //
// ./src/styl/constants.js